import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { SvgIconModule } from '../svg-icon';

import { TimeRangePickerComponent } from './time-range-picker.component';

@NgModule({
    declarations: [TimeRangePickerComponent],
    imports: [
        CommonModule,
        FormsModule,
        SvgIconModule,
        MatDatepickerModule,
        MatNativeDateModule
    ],
    exports: [TimeRangePickerComponent]
})
export class TimeRangePickerModule { }
